<template>
    <div class="grid grid-cols-3 gap-8 max-w-7xl mx-auto">
        <div class="col-span-3 md:col-span-2">
            <div v-if="vehicleDetailsRequired">
                <NewSectionCard title="Quick Pay" description="Fill in the details before you pay. We'll get the rest of your details later">
                    <div class="grid grid-cols-2 gap-6">
                        <div class="col-span-2 md:col-span-1">
                            <TextInput label="Last Name" v-model="last_name" :validation="v$.last_name"></TextInput>
                        </div>
                        <div class="col-span-2 md:col-span-1  md:col-start-1">
                            <TextInput label="Email" v-model="email" :validation="v$.email"></TextInput>
                        </div>
                    </div>
                    <div class="space-y-3 mt-6">
                        <BasicVehicleDetails
                            v-for="(vehicle, index) in vehicles"
                            :key="index"
                            v-model="vehicles[index]"
                            :types="carpark.stay_prices"
                            :product="product"
                            :valet="valet"
                            :is-last="index=== vehicles.length - 1 && index !== 0"
                            @remove="vehicles.pop()"
                        />
                    </div>

                    <div class="mt-4">
                        <AppButton @click="vehicles.push({})">+ Add another vehicle</AppButton>
                    </div>
                </NewSectionCard>
                <div class="flex justify-end py-4">
                    <AppButton @click="onSubmit" variant="blue">Continue to Payment</AppButton>
                </div>
            </div>
            <div v-else>
                <NewSectionCard title="Card Information">
                    <template v-slot:header-right>
                        <button class="text-gray-200 border-b border-dashed hover:text-gray-300" @click="vehicleDetailsRequired = true">
                            <svg class="w-4 h-4 text-white inline-block mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                            </svg>
                            <span>Edit Details</span>
                        </button>
                    </template>
                    <StripePaymentForm @price-change="priceChange" />
                </NewSectionCard>
            </div>
        </div>

        <div class="col-span-3 md:col-span-1 space-y-8">
            <SummaryCard :product="product" :booking="booking" :vehicles="vehicles" :carpark="carpark" />

            <NewSectionCard title="Need Help?">
                <div class="grid grid-cols-2 flex-shrink-0">
                    <div class="col-span-4 md:col-span-2">
                        <span class="block">
                            Trouble completing your payment?
                        </span>

                        <span class="block mt-3">Call our office: <a class="font-bold" href="tel:01313330091">0131 333 0091</a></span>
                        <span class="block mt-3"><strong>We are open 24 / 7</strong></span>
                    </div>
                </div>
            </NewSectionCard>
        </div>

        <AddValetModal v-if="showValetModal" :vehicles="vehicles" @close="showValetModal = false; submitData()"  open=""/>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {
    required,
    email,
    minLength,
    helpers,
} from '@vuelidate/validators';
import axios from 'axios';
import SummaryCard from './SummaryCard.vue';
import BasicVehicleDetails from '../../../../components/frontend/BasicVehicleDetails.vue';
import StripePaymentForm from '../../../../components/frontend/StripePaymentForm.vue';
import AddValetModal from '../../../../components/frontend/AddValetModal.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        SummaryCard,
        BasicVehicleDetails,
        StripePaymentForm,
        AddValetModal,
    },
    data() {
        return {
            vehicleDetailsRequired: true,
            showValetModal: false,
            last_name: null,
            email: null,
            vehicles: [{}],
            promotion: null,
        };
    },
    props: {
        booking: { required: true },
        carpark: { required: true },
        product: { required: true },
        valet: { required: true }
    },
    validations() {
        return {
            last_name: {
                required: withMessage('Last name is required', required),
            },
            email: {
                required: withMessage('Email is required', required),
                email: withMessage('Email format is invalid', email),
            },
            vehicles: {
                required,
                minLength: minLength(1),
            },
        };
    },
    computed: {
        vehiclePayloadData() {
            const vehicleData = [];

            this.vehicles.forEach((vehicle) => {
                vehicleData.push({
                    partySize: vehicle.partySize,
                    registration: vehicle.registration,
                    type: vehicle.type,
                    valet: vehicle.valet?.id,
                });
            });

            return vehicleData;
        },
    },
    methods: {
        priceChange(data) {
            this.vehicles = data.vehicles;
        },
        onSubmit() {
            if (this.vehicles.filter((vehicle) => !!vehicle.valet).length === 0) {
                this.showValetModal = true;
            } else {
                this.submitData();
            }
        },
        async submitData() {
            const result = await this.v$.$validate();

            if (!result) {
                return false;
            }

            return axios.post('/quick-booking', {
                last_name: this.last_name,
                email: this.email,
                vehicles: this.vehiclePayloadData,
            }).then(() => {
                this.vehicleDetailsRequired = false;
            }).catch((error) => {
                this.errors = error.response.data.errors;
            });
        },
    },
    mounted() {
    },
};
</script>
